/*eslint-disable*/
export default sizeGuideButton => {

  let $popup = $('body').find('.size-guide.popup')
  $(window).load(() => {
    $popup.find('.tip-close a').on("click touchstart", function () {
      $popup.css('display', 'none')
      $('body').css('overflow', 'auto')
      $('#wrapper').css('overflow', 'auto')
      $("#wrapper .content.container").css('overflow', 'auto')
      $('body').unbind('click.sizeGuide touchstart.sizeGuide');
    });

    $popup.find('.size-guide_category_header_item').on("click touchstart", (event) => {
      let $event = event
      let closest = $event.target.closest('.size-guide_category_header_item')
      let cat = closest.classList[1].split('_').pop()
      closest.parentElement.classList += " active"

      // Set all other category headers to inactive by removing 'active' class
      let allHeaders = document.querySelectorAll('.size-guide_category_header_item')
      allHeaders.forEach(function (el) {
        if (el.classList[1].split('_').pop() != cat) {
          el.parentElement.classList.remove("active")
        }
      })

      // Set all other category tables to inactive by removing 'active' class
      let allTables = document.querySelectorAll('.size-guide_table')
      allTables.forEach(function (el) {
        if (el.classList[1].split('_').pop() === cat) {
          el.classList += " active"
        } else {
          el.classList.remove("active")
        }
      })
    })
  })


  $(sizeGuideButton).click((event) => {
    $("#wrapper .content.container").css('overflow', 'hidden')
    $('body').css('overflow', 'hidden')
    $('#wrapper').css('overflow', 'hidden')
    $popup.css('display', 'block')
    setTimeout(() => {
      $('body').bind('click.sizeGuide touchstart.sizeGuide', function (e) {
        e.stopImmediatePropagation()
        if (!$(e.target).closest('.size-guide.popup:not(.template)').length) {
          $popup.css('display', 'none')
          $('body').unbind('click.sizeGuide touchstart.sizeGuide');
          $('body').css('overflow', 'auto')
          $('#wrapper').css('overflow', 'auto')
          $("#wrapper .content.container").css('overflow', 'auto')
        }
      });
    }, 10)


  })

}



// WEBPACK FOOTER //
// ./src/scripts/components/size-guide.js